import http from '@/plugins/api'
import * as types from './types'
import { startLoading } from '@/plugins/loading'

export default {
  initSendBird({ commit }, apiId) {
    commit(types.INIT_SENDBIRD, apiId)
  },
  setSearchTerm({ commit }, search) {
    if (search.for === 'user') {
      commit(types.SET_SEARCH_TERM_USER, search.text)
    } else {
      commit(types.SET_SEARCH_TERM, search.text)
    }
  },
  setPageSize({ commit }, page) {
    if (page.for === 'user') {
      commit(types.SET_PAGE_SIZE_USER, page.size)
    } else {
      commit(types.SET_PAGE_SIZE, page.size)
    }
  },
  resetChannels({ commit }) {
    commit(types.RESET_CHANNELS)
  },
  async getChannels({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getChannels', () =>
      http.get(`chat/SendBirdGroupChannels?token=${options.token}&pagesize=${options.pagesize}&search=${encodeURIComponent(options.search)}&includeMembers=1&chatChannelType=${options.channelType}`)
    )
    commit(types.SET_CHANNELS, r.data)
  },
  setChannelChecked({ commit }, data) {
    commit(types.SET_CHANNEL_CHECKED, data)
  },
  resetUsers({ commit }) {
    commit(types.RESET_USERS)
  },
  async getUserChannels({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getChannels', () =>
      http.get(`chat/SendBirdUserChannels?userid=${options.userid}&token=${options.token}&pagesize=${options.pagesize}&search=${encodeURIComponent(options.search)}`)
    )
    commit(types.SET_CHANNELS, r.data)
  },
  setMessageChecked({ commit }, data) {
    commit(types.SET_MESSAGE_CHECKED, data)
  },
  resetMessageList({ commit }) {
    commit(types.RESET_MESSAGES)
  },
  addMessageToList({ commit }, message, hasmore) {
    commit(types.ADD_MESSAGE, message, hasmore)
  },
  setTyping({ commit }, channel) {
    commit(types.SET_TYPING, channel)
  },
  updateChannelMessageCount({ commit }, data) {
    commit(types.SET_CHANNEL_MESSAGE_COUNT, data)
  },
  async getChatHistory({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getChatHistory', () =>
      http.get(`Message/ServiceRequestMessages?id=${id}&language=en`)
    )
    commit(types.SET_MESSAGES, r.data)
    return r
  },
  resetRequests({ commit }) {
    commit(types.RESET_REQUESTS)
  },
  async getServiceRequestsWithMessages({ commit, dispatch }, search) {
    const r = await startLoading(dispatch, 'getServiceRequestsWithMessages', () =>
      http.get(`serviceRequest/ServiceRequestsForList`, {
        params: search
      })
    )
    commit(types.SET_REQUESTS, r.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/actions.js